const createString = (arr, key) => {
  return arr.map(function (obj) {
    return obj[key]
  }).join(',')
}

let generatedData

export const getDonutChartData = (res, themes) => {
  let accounts = []
  let balances = []

  accounts = createString(res, 'accname').split(',')
  balances = createString(res, 'balance').split(',')  

  if (generatedData) {
    generatedData.datasets[0].backgroundColor = [themes.danger, themes.info, themes.primary]
  } else {
    generatedData = {
      labels: accounts,
      datasets: [{
        label: 'Deposits (KES)',
        backgroundColor: [themes.danger, themes.info, themes.primary],
        data: balances,
      }],
    }
  }

  return generatedData
}
